import { useState } from 'react'

type Toggle = () => void
type SetState = (state: boolean) => void
type UseToggle = (initialState?: boolean) => [boolean, Toggle, SetState]

export const useToggle: UseToggle = (initialState = false) => {
  const [state, setState] = useState(initialState)

  const setToggle = () => setState(curr => !curr)

  return [state, setToggle, setState]
}
